import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconCheckmarkCircleOutline, Paragraph, IconChecklistOutline, Spacer, Banner, IconMailOutline, TextButton, Label, Radio, LabeledControl, Input, FormHelp, IconError, Checkbox, token, VisuallyHidden, Text, FormField, IconFaceUnhappyOutline, Anchor, IconLockOutline, IconWarning } from '@zillow/constellation';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import styled from 'styled-components';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _extends from '@babel/runtime/helpers/esm/extends';
import PhoneInput from 'react-phone-number-input/input';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var MFABodyWrapper = styled.div(_templateObject());

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 104px;\n    height: 104px;\n\n    svg {\n        width: 100%;\n        height: 100%;\n        fill: ", ";\n    }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledIconWrapper = styled.div(_templateObject$1(), function (props) {
  return props.theme.constellation.colors.brand;
});

function HeaderIcon(props) {
  var icon = props.icon;
  return /*#__PURE__*/React.createElement(StyledIconWrapper, null, icon);
}

HeaderIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The icon svg to render */
  icon: PropTypes.node.isRequired
} : {};

var ENABLE_ALWAYS_ON_MESSAGE = "You'll enter your password and a one-time code every time you sign in to your account.";
var ENABLE_STEPUP_ONLY_MESSAGE = "You'll enter your password and a code when you sign in but only if accessing secure information.";
var DISABLE_MESSAGE = 'Two-step verification has been successfully deactivated. You can turn it back on anytime.'; // TODO: confirmation screens for updating stepup only/always on

function Confirmation(props) {
  var isDisable = props.isDisable,
      isStepupOnly = props.isStepupOnly;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconCheckmarkCircleOutline, null)
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, isDisable && DISABLE_MESSAGE || isStepupOnly && ENABLE_STEPUP_ONLY_MESSAGE || ENABLE_ALWAYS_ON_MESSAGE));
}

Confirmation.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, the confirmation message will be shown for the disable MFA flow
   */
  isDisable: PropTypes.bool,

  /**
   * If true, the confirmation message will be shown for the enable/update to stepupOnly MFA flow
   */
  isStepupOnly: PropTypes.bool
} : {};

function VerifyAccount(props) {
  var isError = props.isError,
      isPartOfFlow = props.isPartOfFlow;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconChecklistOutline, null)
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isPartOfFlow ? /*#__PURE__*/React.createElement(React.Fragment, null, "First, let\u2019s verify the email associated with your account.", /*#__PURE__*/React.createElement("br", null), "Select") : 'To verify your email, select', "\xA0\u201CSend verification email\u201D and then check your inbox.")), isError && /*#__PURE__*/React.createElement(Spacer, {
    paddingTop: "md"
  }, /*#__PURE__*/React.createElement(Banner, {
    appearance: "error",
    body: "We were unable to send a verification email"
  })));
}

VerifyAccount.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, and error will be shown
   * */
  isError: PropTypes.bool,

  /**
   * If true, the copy will reflect verifying email as part of flow
   */
  isPartOfFlow: PropTypes.bool
} : {};

function VerifyAccountSent(props) {
  var onResendClick = props.onResendClick;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconMailOutline, null)
  }), /*#__PURE__*/React.createElement(Paragraph, null, "Open the email and select the link provided to verify your account.", /*#__PURE__*/React.createElement("br", null), "Didn\u2019t receive an email? \xA0", /*#__PURE__*/React.createElement(TextButton, {
    onClick: onResendClick
  }, "Resend")));
}

VerifyAccountSent.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The function to be called when the resend is clicked */
  onResendClick: PropTypes.func
} : {};

var _MFA_METHOD_LABELS;
var MFA_TEXT_METHOD = 'text';
var MFA_VOICE_METHOD = 'voice';
var MFA_EMAIL_METHOD = 'email';
var MFA_METHOD_LABELS = (_MFA_METHOD_LABELS = {}, _MFA_METHOD_LABELS[MFA_TEXT_METHOD] = 'Text message', _MFA_METHOD_LABELS[MFA_VOICE_METHOD] = 'Phone call', _MFA_METHOD_LABELS[MFA_EMAIL_METHOD] = 'Email', _MFA_METHOD_LABELS);

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    position: static !important;\n    height: 20px !important;\n    width: 20px !important;\n    border: ", "\n        solid !important;\n    left: auto !important;\n    &:hover {\n        border-color: ", " !important;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n    &:after,\n    &::after,\n    &:before,\n    &::before {\n        content: none !important;\n    }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel = styled(Label)(_templateObject$2());
var StyledRadio = styled(Radio)(_templateObject2(), function (props) {
  return props.checked ? "5px " + props.theme.constellation.colors.brand : "2px " + props.theme.constellation.colors.borderDark;
}, function (props) {
  return props.theme.constellation.colors.brand;
});

function ChooseMfaMethod(props) {
  var onMethodChange = props.onMethodChange,
      _props$allowEmail = props.allowEmail,
      allowEmail = _props$allowEmail === void 0 ? true : _props$allowEmail,
      _props$method = props.method,
      method = _props$method === void 0 ? MFA_TEXT_METHOD : _props$method;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showEmail = _React$useState2[0],
      setShowEmail = _React$useState2[1];

  var handleDifferentMethodClick = function handleDifferentMethodClick() {
    setShowEmail(true);
  };

  var handleMethodChange = function handleMethodChange(event) {
    // Remove the "-method"
    onMethodChange(event.target.id.split('-')[0]);
  };

  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "md"
  }, "Choose the method you would like to use to receive your one-time verification code."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LabeledControl, {
    controlId: MFA_TEXT_METHOD + "-method",
    label: /*#__PURE__*/React.createElement(StyledLabel, null, MFA_METHOD_LABELS[MFA_TEXT_METHOD]),
    control: /*#__PURE__*/React.createElement(StyledRadio, {
      name: "2FA-method",
      onChange: handleMethodChange,
      checked: method === MFA_TEXT_METHOD
    })
  }), /*#__PURE__*/React.createElement(LabeledControl, {
    controlId: MFA_VOICE_METHOD + "-method",
    label: /*#__PURE__*/React.createElement(StyledLabel, null, MFA_METHOD_LABELS[MFA_VOICE_METHOD]),
    control: /*#__PURE__*/React.createElement(StyledRadio, {
      name: "2FA-method",
      onChange: handleMethodChange,
      checked: method === MFA_VOICE_METHOD
    })
  }), allowEmail && showEmail && /*#__PURE__*/React.createElement(LabeledControl, {
    controlId: MFA_EMAIL_METHOD + "-method",
    label: /*#__PURE__*/React.createElement(StyledLabel, null, MFA_METHOD_LABELS[MFA_EMAIL_METHOD]),
    control: /*#__PURE__*/React.createElement(StyledRadio, {
      name: "2FA-method",
      onChange: handleMethodChange,
      checked: method === MFA_EMAIL_METHOD
    })
  })), allowEmail && !showEmail && /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "md"
  }, "Don't have access to your phone?\xA0", /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: handleDifferentMethodClick
  }, "Try another method")));
}

ChooseMfaMethod.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The function to be called when a new method is chosen
   */
  onMethodChange: PropTypes.func.isRequired,

  /**
   * The method to use
   */
  method: PropTypes.oneOf([MFA_TEXT_METHOD, MFA_VOICE_METHOD, MFA_EMAIL_METHOD]),

  /**
   * If true, email can be chosen
   */
  allowEmail: PropTypes.bool
} : {};

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    border: 0;\n    caret-color: transparent;\n    clip: rect(0 0 0 0);\n    clip-path: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    &:focus + ", " ", " {\n        border-width: 2px;\n        padding: 7px 0;\n\n        @media (max-width: ", ") {\n            padding: 5px 0;\n        }\n    }\n\n    &:focus + ", " ", ", &:hover + ", " ", " {\n        border-color: ", ";\n    }\n\n    &[isDisabled] + ", " ", " {\n        background: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    margin: auto;\n    max-width: 320px;\n\n    &:hover ", " {\n        ", ";\n    }\n\n    ", " {\n        ", ";\n    }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n    border: 1px solid ", ";\n    border-radius: 2px;\n    display: inline-block;\n    font-family: Tahoma;\n    font-size: 40px;\n    line-height: 1;\n    height: 58px;\n    text-align: center;\n    box-sizing: border-box;\n    width: 48px;\n    padding: 8px 0;\n\n    @media (max-width: ", ") {\n        font-size: 36px;\n        height: 48px;\n        padding: 6px 0;\n        width: 38px;\n    }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var smallScreenBreakpoint = '392px';
var Box = styled.span(_templateObject$3(), function (props) {
  return props.theme.constellation.colors.gray300;
}, smallScreenBreakpoint);
var BoxesWrapper = styled.div(_templateObject2$1(), function (props) {
  return props.isDisabled ? props.theme.constellation.colors.backgroundLight : 'white';
}, function (props) {
  return props.isDisabled ? props.theme.constellation.colors.textLight : props.theme.constellation.colors.textDark;
}, Box, function (props) {
  return !props.isDisabled && "border-color: " + props.theme.constellation.colors.brand + "; cursor: pointer;";
}, Box, function (props) {
  return props.errorMsg && "border-color: " + props.theme.constellation.colors.red400 + " !important;";
});
var VisuallyHiddenInput = styled(Input)(_templateObject3(), BoxesWrapper, Box, smallScreenBreakpoint, BoxesWrapper, Box, BoxesWrapper, Box, function (props) {
  return props.theme.constellation.colors.brand;
}, BoxesWrapper, Box, function (props) {
  return props.theme.constellation.colors.gray200;
});

var CodeInput = function CodeInput(_ref) {
  var errorMsg = _ref.errorMsg,
      maxLength = _ref.maxLength,
      id = _ref.id,
      name = _ref.name,
      isDisabled = _ref.isDisabled;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var inputEl = useRef(null);

  var onBoxesClick = function onBoxesClick() {
    setInputValue('');
    inputEl.current.focus();
  };

  var boxes = [];
  var extraInputProps = {};

  if (errorMsg) {
    extraInputProps.error = true;
    extraInputProps['aria-describedby'] = 'invalid-code-message';
  } // Anytime the state changes update the `boxes` array to reflect the current state.


  for (var index = 0; index < maxLength; index += 1) {
    var char = inputValue.charAt(index);
    boxes[index] = char !== undefined ? char : "\xA0";
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHiddenInput, _extends({
    id: id,
    name: name,
    type: "tel",
    required: true,
    ref: inputEl,
    maxLength: maxLength,
    pattern: "[est0-9]{" + maxLength + "}",
    disabled: isDisabled,
    value: inputValue,
    autocomplete: "off",
    onChange: function onChange(e) {
      return setInputValue(e.target.value);
    }
  }, extraInputProps)), /*#__PURE__*/React.createElement(BoxesWrapper, {
    onClick: onBoxesClick,
    error: errorMsg,
    isDisabled: isDisabled,
    "aria-hidden": true
  }, boxes.map(function (boxValue, index) {
    var boxId = "input-box-" + index;
    return /*#__PURE__*/React.createElement(Box, {
      key: boxId
    }, boxValue);
  })), errorMsg && /*#__PURE__*/React.createElement(FormHelp, {
    id: "invalid-code-message",
    error: true,
    as: "p",
    marginTop: "xs"
  }, /*#__PURE__*/React.createElement(IconError, {
    "aria-hidden": "true"
  }), " ", errorMsg));
};

CodeInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Disables the text input
   */
  isDisabled: PropTypes.bool,

  /**
   * Error message to be displayed
   */
  errorMsg: PropTypes.string,

  /**
   * ID prop for the input. Maps to the label.
   */
  id: PropTypes.string,

  /**
   * Max length of the code
   */
  maxLength: PropTypes.number,

  /**
   * Input name
   */
  name: PropTypes.string
} : {};
CodeInput.defaultProps = {
  isDisabled: false,
  errorMsg: '',
  id: '',
  maxLength: 6,
  name: ''
};

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n    &:after,\n    &::after,\n    &:before,\n    &::before {\n        content: none !important;\n    }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n    align-self: center;\n    position: static !important;\n    width: 20px !important;\n    height: 20px !important;\n    border: 2px solid ", " !important;\n    left: auto !important;\n    margin-top: 0 !important;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: center;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabeledControl = styled(LabeledControl)(_templateObject$4()); // Override conflicts from a ZSG file

var OverrideZsgCheckbox = styled(Checkbox)(_templateObject2$2(), token('colors.borderDark')); // Override conflicts from a ZSG file

var OverrideZsgLabel = styled(Label)(_templateObject3$1());

function EnterVerificationCode(props) {
  var inputError = props.inputError,
      onResendClick = props.onResendClick,
      onDifferentMethodClick = props.onDifferentMethodClick,
      _props$showDifferentM = props.showDifferentMethodOption,
      showDifferentMethodOption = _props$showDifferentM === void 0 ? false : _props$showDifferentM,
      onVoiceCodeClick = props.onVoiceCodeClick,
      _props$showGetACallOp = props.showGetACallOption,
      showGetACallOption = _props$showGetACallOp === void 0 ? false : _props$showGetACallOp,
      onRememberDeviceChange = props.onRememberDeviceChange,
      disableControls = props.disableControls,
      _props$showRememberDe = props.showRememberDevice,
      showRememberDevice = _props$showRememberDe === void 0 ? true : _props$showRememberDe,
      _props$showSetupMessa = props.showSetupMessage,
      showSetupMessage = _props$showSetupMessa === void 0 ? false : _props$showSetupMessa,
      _props$method = props.method,
      method = _props$method === void 0 ? MFA_TEXT_METHOD : _props$method,
      sentTo = props.sentTo,
      _props$description = props.description,
      description = _props$description === void 0 ? DefaultDescription({
    method: method,
    sentTo: sentTo,
    showSetupMessage: showSetupMessage
  }) : _props$description,
      _props$supportText = props.supportText,
      supportText = _props$supportText === void 0 ? null : _props$supportText;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "md"
  }, description), /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Label, {
    controlId: "mfa-code"
  }, "Enter 6-digit code")), /*#__PURE__*/React.createElement(CodeInput, {
    id: "mfa-code",
    name: "code",
    maxLength: 6,
    "aria-hidden": true,
    errorMsg: inputError,
    isDisabled: disableControls
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, "Didn't get a code?\xA0", /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: onResendClick,
    disabled: disableControls
  }, "Try again"), showGetACallOption && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0or\xA0", /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: onVoiceCodeClick
  }, "Get a call")), showDifferentMethodOption && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0or\xA0", /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: onDifferentMethodClick
  }, "try another method"))), showRememberDevice && /*#__PURE__*/React.createElement(StyledLabeledControl, {
    marginTop: "lg",
    labelPosition: "right",
    controlId: "mfa-remember-me",
    label: /*#__PURE__*/React.createElement(OverrideZsgLabel, {
      htmlFor: "mfa-remember-me"
    }, /*#__PURE__*/React.createElement(Text, null, "Remember this device for 7 days")),
    control: /*#__PURE__*/React.createElement(OverrideZsgCheckbox, {
      id: "mfa-remember-me",
      name: "rememberDevice",
      onChange: onRememberDeviceChange,
      disabled: disableControls
    })
  }), supportText);
}

function DefaultDescription(_ref) {
  var method = _ref.method,
      sentTo = _ref.sentTo,
      showSetupMessage = _ref.showSetupMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, "You should have received your 6-digit verification code via\xA0", MFA_METHOD_LABELS[method].toLowerCase(), sentTo ? " at " + sentTo : '', ".", showSetupMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), "Enter the code to finish setting up 2-step verification."));
}

DefaultDescription.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, the setup 2FA message will be shown
   */
  showSetupMessage: PropTypes.bool,

  /**
   * The method the code was sent from
   */
  method: PropTypes.oneOf([MFA_TEXT_METHOD, MFA_VOICE_METHOD, MFA_EMAIL_METHOD]),

  /**
   * The name of the destination where the code was sent
   */
  sentTo: PropTypes.string
} : {};
EnterVerificationCode.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The error to show under the code input
   */
  inputError: PropTypes.string,

  /**
   * Function to call when a code resend is requested
   */
  onResendClick: PropTypes.func.isRequired,

  /**
   * The function to call when a different method is requested
   */
  onDifferentMethodClick: PropTypes.func,

  /**
   * If true, the try different method will be shown
   */
  showDifferentMethodOption: PropTypes.bool,

  /**
   * The function to call when remember device is changed
   */
  onRememberDeviceChange: PropTypes.func,

  /**
   * If true, the controls will be disabled
   */
  disableControls: PropTypes.bool,

  /**
   * @deprecated The MFA account-settings screens will no longer support this feature.
   * If true, the remember device checkbox will be shown
   */
  showRememberDevice: PropTypes.bool,

  /**
   * If true, the setup 2FA message will be shown
   */
  showSetupMessage: PropTypes.bool,

  /**
   * The method the code was sent from
   */
  method: PropTypes.oneOf([MFA_TEXT_METHOD, MFA_VOICE_METHOD, MFA_EMAIL_METHOD]),

  /**
   * The name of the destination where the code was sent
   */
  sentTo: PropTypes.string,

  /**
   * The description text in the body of the modal
   */
  description: PropTypes.element,

  /**
   * Additional support text
   */
  supportText: PropTypes.element,

  /**
   * Function to call when user wants a phone call instead of text
   */
  onVoiceCodeClick: PropTypes.func,

  /**
   * If true, show the 'Get a Call' option
   */
  showGetACallOption: PropTypes.bool
} : {};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n    text-align: left;\n    width: 100%;\n    max-width: 309px;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledFormField = styled(FormField)(_templateObject$5());
var defaultDescription = 'Enter the phone number you want to use and we’ll send you text message with your verification code. SMS rates may apply.';

function SendVerificationCode(props) {
  var description = props.description,
      phone = props.phone,
      onPhoneChange = props.onPhoneChange,
      isError = props.isError;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "md"
  }, description || defaultDescription), /*#__PURE__*/React.createElement(StyledFormField, {
    controlId: "MFA-phone-input",
    label: /*#__PURE__*/React.createElement(Label, null, "Phone number"),
    control: /*#__PURE__*/React.createElement(Input, {
      country: "US",
      name: "phoneNo",
      id: "mfa-phone",
      as: PhoneInput,
      value: phone,
      onChange: onPhoneChange
    })
  }), isError && /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "xl"
  }, /*#__PURE__*/React.createElement(Banner, {
    appearance: "error",
    body: "We were unable to use that phone number."
  })));
}

SendVerificationCode.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The description to be shown
   */
  description: PropTypes.element,

  /**
   * The function to be called when the phone number changes
   */
  onPhoneChange: PropTypes.func.isRequired,

  /**
   * The phone number
   */
  phone: PropTypes.string,

  /**
   * If true, error will be shown
   */
  isError: PropTypes.bool
} : {};

function VerificationCodeError(props) {
  var onCodeResend = props.onCodeResend,
      _props$resendingIsDis = props.resendingIsDisabled,
      resendingIsDisabled = _props$resendingIsDis === void 0 ? false : _props$resendingIsDis;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconFaceUnhappyOutline, null)
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, "You can try again by \xA0", /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: onCodeResend,
    disabled: resendingIsDisabled
  }, "requesting a new code.")), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, "If you continue to have issues,\xA0", /*#__PURE__*/React.createElement(Anchor, {
    href: "https://zillow.zendesk.com/hc/en-us/"
  }, "submit a support request.")));
}

VerificationCodeError.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The function to call when a new code is requested
   */
  onCodeResend: PropTypes.func.isRequired,

  /**
   * If true, resending will be disabled
   */
  resendingIsDisabled: PropTypes.bool
} : {};

function AccountLocked(props) {
  var _props$alreadyLocked = props.alreadyLocked,
      alreadyLocked = _props$alreadyLocked === void 0 ? false : _props$alreadyLocked;
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconLockOutline, null)
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, alreadyLocked ? 'You account is locked' : 'Your account has been locked because of too many requests.'));
}

AccountLocked.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, the account notice will provide a message of already locked
   */
  alreadyLocked: PropTypes.bool
} : {};

var CONFIRMATION_MESSAGE = 'Since you are impersonating a user, the below button will disable MFA for that user without OTP verification. Please be sure this is what you want to do.';

function AdminDisableConfirmation() {
  return /*#__PURE__*/React.createElement(MFABodyWrapper, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    icon: /*#__PURE__*/React.createElement(IconWarning, null)
  }), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, CONFIRMATION_MESSAGE));
}

/**
 * Formats a phone number string to something easier on the eyes. Example string: `+14132850623`.
 * @param {String} phoneNumber phone number string to be parsed
 * @param {Boolean} obfuscate if true, replaces the area code and prefix with Xs.
 */
var formatPhoneNumber = function formatPhoneNumber(phoneNumber, obfuscate) {
  if (obfuscate === void 0) {
    obfuscate = false;
  }

  if (phoneNumber) {
    var match = phoneNumber.match(/^(\+1|)?([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})$/);

    if (match) {
      var intlCode = match[1] ? '+1 ' : '';

      if (obfuscate) {
        match[2] = 'XXX';
        match[3] = 'XXX';
      }

      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
  }

  return phoneNumber;
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatPhoneNumber: formatPhoneNumber
});

export { AccountLocked, AdminDisableConfirmation, ChooseMfaMethod as ChooseMFAMethod, CodeInput, Confirmation, EnterVerificationCode, MFA_EMAIL_METHOD, MFA_TEXT_METHOD, MFA_VOICE_METHOD, SendVerificationCode, VerificationCodeError, VerifyAccount, VerifyAccountSent, index as utils };
